import { Avatar, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import { apiUrl } from "config/settings";
import { useDispatch, useSelector } from "react-redux";
import { endpointName } from "../const";
import useDataManager from "hooks/useDataManager";
import { setList } from "store/servicesCallSlice";
import { setShowLoading, setShowMassage } from "store/sysSlice";
import http from '../../../http'
import { useEffect, useState } from "react";

const { default: CustomDialog } = require("components/CustomDialog")

const SelectEmp = ({ data, setData, list }) => {
    const dispatch = useDispatch()
    const { editItem } = useDataManager()
    const employees = useSelector((state) => state?.employees?.list);
    const [associatedEmp, setAssociatedEmp] = useState("")

    useEffect(() => {
        if (data?.call?.employee) {
            const emp = employees?.find(emp => emp?.id === data?.call?.employee)
            if (emp)
                setAssociatedEmp(emp?.id)
        }
    }, [data]);

    const onClose = () => {
        setData({ open: false, call: null })
    }

    const onClick = (empId) => {
        dispatch(setShowLoading(true));
        const call = data?.call

        http.patch(`${apiUrl}/${endpointName}/${call?._id}`, { employee: empId })
            .then((res) => {
                dispatch(setShowLoading(false));
                const item = { _id: call?.id, ...call, employee: empId };
                const newList = editItem(item, list);
                dispatch(setList(newList));
                dispatch(setShowLoading(false));
                dispatch(setShowMassage({ massage: "CHANGE_EMP_SUCCESS", type: "success" }));
                onClose()
            })
            .catch((error) => {
                dispatch(setShowLoading(false));
                dispatch(setShowMassage({ massage: "ERROR", type: "error" }));
            })
    }

    if (employees.length === 0) return

    return (
        <CustomDialog open={data?.open} onClose={onClose} title='SELECT_EMP'>
            <List
                sx={{
                    width: '100%',
                    maxWidth: 360,
                    position: 'relative',
                    overflow: 'auto',
                    maxHeight: 300,
                    '& ul': { padding: 0 },
                }}
                subheader={<li />}
            >
                {employees?.map((emp, idx) => {
                    return (
                        <ListItemButton
                            disabled={associatedEmp === emp?.id}
                            onClick={() => onClick(emp?.id)}
                            key={idx}
                        >
                            <ListItemAvatar><Avatar /></ListItemAvatar>
                            <ListItemText primary={`${emp?.fn} ${emp?.ln}`} />
                        </ListItemButton>
                    )
                })}
            </List>
        </CustomDialog>
    )
}

export default SelectEmp